export const buildUnmanagedLayersConfig = (tinkerConfig, nonTranslatableResourceStrings) => {
    const unmanagedLayers = tinkerConfig.mapLayers.edges
        .map((mapLayer) => mapLayer.node)
        .filter((mapLayer) => !mapLayer.isInMapSwitcher && !mapLayer.isInLayerSwitcher);
    unmanagedLayers.forEach((layer) => {
        nonTranslatableResourceStrings[`layer.${layer.nameId}`] = layer.title ?? '';
        if (layer.mapBoxStyleLegend && Array.isArray(layer.mapBoxStyleLegend)) {
            layer.mapBoxStyleLegend.forEach((item) => {
                nonTranslatableResourceStrings[`legend.${layer.nameId}.${item.id}`] = item.label || item.id;
            });
        }
    });
};
//# sourceMappingURL=buildUnmanagedLayersConfig.js.map